export default __webpack_public_path__ + "f5b46d58ccd841025f91551dc4df6cd2.png";